(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar-suggestions.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar-suggestions.js');

'use strict';

const {
  ListItemLink
} = svs.ui.ReactListGroup;
const {
  ReactBadge: Badge,
  ReactIcon
} = svs.ui;
const Item = _ref => {
  let {
    longname,
    subcategory,
    supporters,
    points
  } = _ref;
  return React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xs-12 margin-bottom-1"
  }, longname, subcategory === '' ? React.createElement(Badge, {
    className: "grassroots-badge margin-left-1"
  }, "Huvudf\xF6rening") : " - ".concat(subcategory)), React.createElement("p", {
    className: "grassroots-searchbar-suggestion-supporters-points "
  }, React.createElement(ReactIcon, {
    className: "padding-right-1",
    icon: "players",
    size: "200"
  }), React.createElement("span", null, supporters.toLocaleString('sv-SE'), ' ', "st"), React.createElement(ReactIcon, {
    className: "margin-left-1 padding-right-1",
    icon: "points",
    size: "200"
  }), points.toLocaleString('sv-SE'), ' ', "p"));
};
const SearchBarSuggestions = _ref2 => {
  let {
    searchResult,
    onClick,
    onKeyDown
  } = _ref2;
  return searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(receiver => React.createElement(ListItemLink, {
    key: receiver.id
  }, React.createElement("div", {
    className: "padding-1",
    onClick: () => onClick(receiver),
    onKeyDown: event => onKeyDown(event, receiver),
    tabIndex: 0
  }, React.createElement(Item, receiver))));
};
svs.grassroots.components.searchbar_section.SearchBarSuggestions = SearchBarSuggestions;

 })(window);